import { create } from "zustand";
const useAnimeStore = create((set) => ({
  allAnimes: [],
  setAllAnimes: (toUpdate) => {
    set((state) => ({ allAnimes: toUpdate }));
  },
  shuffledAnime: [],
  setShuffledAnime: (toUpdate) => {
    set({ shuffledAnime: toUpdate });
  },
  homepageData: null,
  setHomepageData: (data) => set({ homepageData: data }),
}));

export default useAnimeStore;
